// Carrier Matrix clients get a quick link on the nav bar (MarketPreView only) and are
// treated as Read-Only accessible to every colleague, even without an AON Staff association,
// unless the colleague already has an explicit Full Access record. Client GUIDs are
// environment-specific and tokenized per env in the vars/ folder.
export var carrierMatrixClients = [
    { label: "Carrier Matrix - US", clientGuid: import.meta.env.VITE_CARRIER_MATRIX_CLIENT_ID_US },
    { label: "Carrier Matrix - LATAM", clientGuid: import.meta.env.VITE_CARRIER_MATRIX_CLIENT_ID_LATAM },
    { label: "Carrier Matrix - Asia", clientGuid: import.meta.env.VITE_CARRIER_MATRIX_CLIENT_ID_ASIA },
];
// Guids are compared case-insensitively: the env-configured values and the guids the
// client dropdown API returns are not guaranteed to share the same casing.
export var isCarrierMatrixClient = function (clientGuid) {
    return !!clientGuid && carrierMatrixClients.some(function (client) { return !!client.clientGuid && client.clientGuid.toLowerCase() === clientGuid.toLowerCase(); });
};
